<template>
    <div id="home" style="flex-grow: 1;" v-loading.fullscreen.lock="changeLoading">
      <Loading :loading="submitLoading" />
      <div style="background-color: white; margin: 10px 20px">
        <div>
          <!--search area-->
          <el-form :inline="true" class="demo-form-inline">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="酒店名称:">
                  <el-input v-model="searchForm.hotelName" placeholder="请输入酒店名称" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 目的城市子组件 returnParentValue：给子组件赋值   returnParentValue：子组件返回值（调用方法接收）-->
                <destination
                  :returnParentValue="searchForm.cityName"
                  :parentCityCode="searchForm.cityCode"
                  @returnCityInfo="setDestination"
                  :isHotCity="false"
                ></destination>
              </el-col>
              <el-col :span="9">
                <el-date-picker v-model="dateValue" type="daterange" range-separator="至" start-placeholder="入住时间" end-placeholder="离店时间"></el-date-picker>
              </el-col>
            </el-row>
            <el-divider>使用上面或者下面进行数据查询</el-divider>
            <el-row :gutter="20">
              <el-col :span="16">
                <el-form-item label="酒店Id:">
                  <el-input v-model="hotelIds" style="width: 43.4rem;" autocomplete="off" placeholder="多个酒店Id请用,隔开最多填写30个酒店Id"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="warning" class="harpIDbtn" @click="searchHotel()">搜索</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-divider class="title-divider"></el-divider>
          <el-divider v-if="showDivider" class="title-divider">静态数据</el-divider>
          <el-table :data="tableStaticData" v-show="tableStaticData.length > 0" border style="margin-top: 15px;">
            <el-table-column prop="id" label="FX酒店ID" align="center"></el-table-column>
            <el-table-column prop="name.zh-CN" label="酒店名称-中文" align="center"></el-table-column>
            <el-table-column prop="name.en" label="酒店名称-英文" align="center"></el-table-column>
            <el-table-column prop="contactNumber" label="联系电话" align="center"></el-table-column>
            <el-table-column prop="countryName" label="国家" align="center"></el-table-column>
            <el-table-column prop="provinceName" label="省份" align="center"></el-table-column>
            <el-table-column prop="cityName" label="城市" align="center"></el-table-column>
            <el-table-column prop="address.zh-CN" label="中文地址" align="center"></el-table-column>
            <el-table-column prop="address.en" label="英文地址" align="center"></el-table-column>
            <el-table-column prop="bookingDeptEmail" label="酒店预订部邮箱" align="center"></el-table-column>
            <el-table-column prop="isActive" label="是否在售" align="center">
              <template #default="{ row }">
                <i v-if="row.isActive" class="el-icon-check" style="color: green;"></i>
                <i v-if="!row.isActive" class="el-icon-close" style="color: red;"></i>
              </template>
            </el-table-column>
          </el-table>
          <el-divider v-if="showDivider" class="title-divider">FX实时数据</el-divider>
          <div v-if="showTraceId" style="padding: 10px 0;font-size: 14px;">
            TraceId:<span style="color: #fc6640;">{{traceId}}</span>
          </div>
          <div v-if="showNodata" style="padding: 10px 0;font-size: 14px;text-align: center;">
            <span style="color: #fc6640;">未查到酒店,可能此酒店被付迅方配置的关键字屏蔽，请换一个关键字搜索。</span>
          </div>
          <el-table :data="tableHotelAreaData" v-show="tableHotelAreaData.length > 0" border style="margin-top: 15px;">
            <el-table-column prop="hotelDescriptiveInfo.id" label="FX酒店ID" align="center" width="120"></el-table-column>
            <el-table-column prop="hotelDescriptiveInfo.name.zh-CN" label="酒店名称-中文" align="center" width="200"></el-table-column>
            <el-table-column prop="hotelDescriptiveInfo.name.en" label="酒店名称-英文" align="center" width="200"></el-table-column>
            <el-table-column prop="hotelDescriptiveInfo.contactNumber" label="联系电话" align="center" width="150"></el-table-column>
            <el-table-column prop="hotelDescriptiveInfo.address.zh-CN" label="中文地址" align="center" width="250"></el-table-column>
            <el-table-column prop="hotelDescriptiveInfo.address.en" label="英文地址" align="center" width="250"></el-table-column>
            <el-table-column prop="hotelDescriptiveInfo.bookingDeptEmail" label="酒店预订部邮箱" align="center" width="250"></el-table-column>
            <el-table-column prop="isActive" label="是否在售" align="center">
              <template #default="{ row }">
                <el-button size="default" @click="handleSearch(row)">查询</el-button>
                <el-icon v-if="row.isActive" color="green" size="16px" style="padding-left: 30px;"><Check /></el-icon>
                <el-icon v-else-if="row.isActive === false" color="red" size="16px" style="padding-left: 30px;"><Close /></el-icon>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="tableData" v-show="tableData.length > 0" border style="margin-top: 15px;">
            <el-table-column prop="sourceId" label="FX酒店ID" align="center"></el-table-column>
             <el-table-column prop="data.name.zh-CN" label="酒店名称-中文" align="center"></el-table-column>
            <el-table-column prop="data.name.en" label="酒店名称-英文" align="center"></el-table-column>
            <el-table-column prop="contactNumber" label="联系电话" align="center"></el-table-column>
            <el-table-column prop="cityName" label="城市" align="center"></el-table-column>
            <el-table-column prop="data.address.zh-CN" label="地址" align="center"></el-table-column>
            <el-table-column prop="startRating" label="星级" align="center"></el-table-column>
            <el-table-column prop="data.bookingDeptEmail" label="酒店预订部邮箱" align="center"></el-table-column>
          </el-table>
        </div>
      </div>
      <ConfirmBoxs
        :centerDialogVisible="confirmFlag"
        :confirmMsg="confirmMsg"
        @setConfirmFlag="setConfirmFlag"
      ></ConfirmBoxs>
    </div>
  </template>
    
    <script>
  import { getHotelList, getHotelLookup, hotelArea,getHotelSaleable } from "@/api/shoppingData";
  import { Check, Close } from '@element-plus/icons-vue'
  import Loading from "@/components/Loading.vue";
  import ConfirmBoxs from "@/components/confirmBoxs.vue";
  import DatePicker from "@/components/DatePicker.vue";
  import { formatDateTime } from "@/utils/utils.js";
  import Destination from "@/components/Destination.vue";
  export default {
    name: "HBEHotelDataSearch",
    components: {
      DatePicker,
      ConfirmBoxs,
      Loading,
      Destination,
      Check,
      Close
    },
    data() {
      return {
        dateValue: '',
        changeLoading: false,
        hotelIds: "",
        tableData: [],
        confirmMsg: "",
        confirmFlag: false,
        submitLoading: false,
        searchForm: {
          hotelName: "",
          checkInDate: "",
          checkOutDate: "",
          cityInfo: {
            cityInfo:{
              countryCode: "", //国家ID
            }
          }, //目的城市信息
          cityCode: "",
          cityName: "",
        },
        tableStaticData: [],
        tableHotelAreaData: [],
        showDivider:false,
        showTraceId:false,
        traceId: "",
        showNodata:false
      };
    },
    methods: {
      async getHotelsById() {
        let searchparams = {
          params: {
            hotelIds: this.hotelIds,
            isSearch: true,
          },
        };
        await getHotelList(searchparams)
          .then((res) => {
            this.showTraceId = true;
            this.traceId = res.data.traceId;
            if (res.code === 200) {
              this.tableData = res.data.items;
              this.showNodata = res.data.items.length == 0 ? true : false;
            }
          })
          .catch(function (error) {
            console.log("酒店信息 请求失败", error.objError);
          });
      },
      //获取静态酒店列表信息
      async getStaticHotelList() {
        let hotelParam = {
          params: {
            page: 1,
            per_page: 5,
            hotelName: this.searchForm.hotelName,
            hotelIds: this.hotelIds,
            cityCode: this.searchForm.cityInfo.cityCode,
            countryCode: this.searchForm.cityInfo.cityInfo.countryCode,
          },
        };
        let that = this;
        await getHotelLookup(hotelParam)
          .then((res) => {
            if (res.data.items.length == 0) {
              this.confirmFlag = true;
              this.confirmMsg = "未找到酒店信息";
            } else {
              that.tableStaticData = res.data.items;
            }
          })
          .catch(function (error) {
            console.log("酒店信息 请求失败", error.objError);
          });
      },
      //获取动态酒店列表信息
      async getHotelAreaList() {
        let Hotelparams = {
          posCode: "YGO00001",
          //countryCode: "100000", //国家ID
          //cwtCityCode: "110100", //"310100"
          countryCode: this.searchForm.cityInfo.cityInfo.countryCode, //国家ID
          cwtCityCode: this.searchForm.cityInfo.cityCode, //"310100"
          checkInDate: formatDateTime(this.searchForm.checkInDate, "YYYY-MM-DD"),
          checkOutDate: formatDateTime(this.searchForm.checkOutDate,"YYYY-MM-DD"),
          keyword: this.searchForm.hotelName,
          Language: ["en-US", "zh-CN"],
          pageRequest: {
            page: 1,
            per_page: 5,
          },
        };
        let that = this;
        await hotelArea(Hotelparams)
          .then((res) => {
            that.showTraceId = true;
            that.traceId = res.data.traceId;
            if (res.data.error.code != 0) {
            //   this.confirmFlag = true;
            //   this.confirmMsg = "未找到酒店信息";
            that.showNodata = true;
            } else {
              that.tableHotelAreaData = res.data.hotelList;
              that.showNodata = res.data.hotelList.length == 0 ? true : false;
            }
          })
          .catch(function (error) {
            console.log("酒店信息 请求失败", error.objError);
          });
      },
      //搜索button
      async searchHotel() {
        console.log(this.searchForm.cityCode);
        if(this.dateValue){
          this.searchForm.checkInDate = formatDateTime(this.dateValue[0],"YYYY-MM-DD");
          // 离店
          this.searchForm.checkOutDate = formatDateTime(this.dateValue[1],"YYYY-MM-DD");
        }
        let searchStaticFlag = true;
        if (this.dateValue && this.searchForm.cityCode != "") {
          searchStaticFlag = false;
        }
        if (searchStaticFlag && this.searchForm.hotelName == "" && this.hotelIds == '') {
          this.confirmFlag = true;
          this.confirmMsg = "请选择目的城市、入离日期或输入酒店id、酒店名称";
          return;
        }
        this.tableData = [];
        this.tableStaticData = [];
        this.tableHotelAreaData = [];
        this.submitLoading = true;
        this.showDivider = true;
        this.showTraceId = false;
        this.showNodata = false;
        if(this.hotelIds != ''){ // 按照酒店ID来查询
          await this.getHotelsById();// 获取FX动态酒店列表信息hotels/list接口
        }else if(!searchStaticFlag){// 按照国家和入离日期来查询
          await this.getHotelAreaList();// 获取FX动态酒店列表信息hotels/search接口
        }
        await this.getStaticHotelList();// 获取静态酒店列表信息
        this.submitLoading = false;
      },
  
      setConfirmFlag(value) {
        this.changeLoading = false;
        this.confirmFlag = value;
      },
      // 子组件赋值目的城市 destination组件
      setDestination(value) {
        if (value.cityInfo) {
          this.searchForm.cityCode = value.cityInfo.cityCode;
          this.searchForm.cityInfo = value;
        }else {
          this.searchForm.cityCode = '';
          this.searchForm.cityInfo.cityInfo.countryCode = '';
        }
      },
      handleSearch(row) {
        let params = {
          params: {
            hotelId: row.hotelDescriptiveInfo.id,
          },
        };
        getHotelSaleable(params)
          .then((res) => {
            if (res.code == 200) {
              row.isActive = !!res.message
              //this.$set(row, 'isActive', res.message !="" ? true : false); 
            }
          })
       
      },
    },
  };
  </script>
    
    <style scoped>
  .loading {
    z-index: 999999;
  }
  .paginationsty {
    float: right;
    margin: 1rem 0;
  }
  .harpIDbtn {
    width: 10rem;
    height: 3rem;
    padding: 0 !important;
    font-size: 1rem !important;
  }
  .demo-form-inline{
    margin-left: 6rem;
    padding-top: 2rem
  }
  .title-divider {
    margin-bottom: 0px;
    height: 2px;
  }
  </style>
